// tslint:disable-next-line:no-stateless-class
// tslint:disable-next-line:export-name
export class AppSessionPurpose {
    public static UNDEFINED: string = "Undefined";
    public static APP_TRIGGER: string = "AppTrigger";
    public static INSTRUMENT_RUN: string = "InstrumentRun";
    public static APP_UPLOAD: string = "AppUpload";
    public static INTERACTIVE_ACTION: string = "InteractiveAction";
    public static DEPENDENCY_CHECKING: string = "DependencyChecking";
}
